// extracted by mini-css-extract-plugin
export var profilePicture = "index-module--profilePicture--BmYLl";
export var photographers = "index-module--photographers--1fszl";
export var photographer = "index-module--photographer--07Lhn";
export var details = "index-module--details--4r+96";
export var instagram = "index-module--instagram--B4iXk";
export var gallery = "index-module--gallery--A+4mJ";